import React, { useState } from 'react';
import { Dialog, useMediaQuery, CircularProgress } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useLogin, useLoginService, useResendOTP } from '../hooks/useRegisterData';
import LoginOTPPopUp from './Login popUps/LoginOTPPopUp';
import CustomizedSnackbars from '../components/Alert';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useExceptionHandler } from '../hooks/useExceptionLogger';
import { ENCRYPTION_TYPE, EncryptDecrypt } from '../utility/encryption';

let isSubmitting = false;
const INITIAL_FORM_STATE_Login = {
  emailId: '',
  mobile: '',
  serviceName: '',
  strategyName: '',
  serviceNameSelected: null,
  strategyNameSelected: null,
  isRequiredServiceName: false,
  isRequiredStrategyName: false,
};
const FORM_VALIDATION_Login = Yup.object().shape({
  emailId: Yup.string()
    .trim('No white space allowed')
    .strict(true)
    .email('Invalid Email Id')
    .required('Email Id is required'),
  mobile: Yup.string()
    .required('Mobile number is required')
    .matches(/^(?!^[0-5])\d{10}$/, 'Invalid mobile number'),
  serviceName: Yup.string().when('isRequiredServiceName', {
    is: true,
    then: Yup.string().required('Service Name is required'),
    otherwise: Yup.string(),
  }),
  strategyName: Yup.string().when('isRequiredStrategyName', {
    is: true,
    then: Yup.string().required('Strategy Name is required'),
    otherwise: Yup.string(),
  }),
});
const apiMessages = {
  DOES_NOT_EXISTS: 'This website does not exist in the database',
  ERROR: 'Oops something went wrong.',
  TRANSACTION_COMPLETED: 'The client transaction has been successfully completed',
  IN_VERIFICATION: 'The client transaction is currently under verification by the operation.',
  OTP_GENERATED: 'OTP was generated successfully.',
};
const numberRegEx = /^[0-9\b]+$/;
const LoginPage = ({ isOpen }) => {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [alert, setAlert] = useState({ counter: 0, type: '', msg: '' });
  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const [useData, setUseData] = useState(INITIAL_FORM_STATE_Login);
  const [transactionID, setTransactionID] = useState('');
  const [services, setServices] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [users, setUsers] = useState([]);
  // This function is used to assign Formiks setfieldvalue function functionality to this setFieldFunction
  let setFieldFunction = { setFieldValue: () => {} };
  const { mutate: HandleException } = useExceptionHandler();

  React.useEffect(() => {
    const fetchData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      sessionStorage.setItem('query', window.location.search);
      const kycrequestParam = urlParams.get('kycrequest');
      if (!kycrequestParam) return;
      let decodedURLData;
      try {
        decodedURLData = decodeURIComponent(kycrequestParam);
      } catch {
        decodedURLData = kycrequestParam;
      }

      const JSONvalue = decodedURLData.includes('emailKycId')
        ? decodedURLData
        : EncryptDecrypt(decodedURLData, ENCRYPTION_TYPE?.DECRYPT);
      try {
        const value = JSON.parse(JSONvalue);
        if (value?.transactionId) setTransactionID(value.transactionId);
        ['emailId', 'mobile'].forEach((field) =>
          setFieldFunction?.setFieldValue(field, value?.[field]),
        );
        setUseData({
          emailid: value?.emailId,
          emailKycId: value?.emailKycId,
          mobile: value?.mobile,
          serviceName: value?.serviceId,
          strategyId: value?.strategyId,
        });
      } catch (error) {
        HandleException({
          logData: { message: error.message, stack: error.stack },
          module: 'Register: handleSignUp method',
        });
      }
    };

    fetchData();
  }, []);

  const onSuccess = (data) => {
    let caughtError;
    isSubmitting = false;
    const decryptedData = data?.data?.body;
    try {
      if (data?.code === 'ERR_NETWORK') showAlert('error', apiMessages?.ERROR);
      if (data?.status === 204) showAlert('error', apiMessages?.DOES_NOT_EXISTS);
      if (data?.response?.status === 500) showAlert('error', apiMessages?.ERROR);
      if (data?.response?.status === 400)
        if (
          data?.response?.data?.message === apiMessages?.TRANSACTION_COMPLETED ||
          data?.response?.data?.message === apiMessages?.IN_VERIFICATION
        )
          showAlert('success', data?.response?.data?.message);
        else showAlert('error', data?.response?.data?.message);

      if (data?.status === 200) {
        if (data?.data?.message === apiMessages?.OTP_GENERATED) {
          setUserId(decryptedData?.userId);
          setTransactionID(decryptedData?.transactionId || '');
          handleClickOpen();
          setFieldFunction?.setFieldValue('isRequiredServiceName', false);
        }
        const user = decryptedData?.user;
        setUsers(() => user);
        if (user?.length === 0) setFieldFunction?.setFieldValue('isRequiredServiceName', false);
        if (user?.length === 1) {
          setUserId(decryptedData?.userId);
          setTransactionID(decryptedData?.transactionId || '');
          handleClickOpen();
          setFieldFunction?.setFieldValue('isRequiredServiceName', false);
        }
        if (user?.length > 1) {
          setFieldFunction?.setFieldValue('isRequiredServiceName', true);
          const service = decryptedData?.user;
          const arrayData = service?.map((item) => ({
            label: item?.serviceName,
            value: item?.serviceId,
            TransValue: item?.transactionId,
          }));
          setServices(() => arrayData?.filter((i) => i?.label && i?.value));
        }
      }
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: 'Login : login method' };
      HandleException(logError);
    }
  };
  const mapStrategies = (serviceId) => {
    let caughtError;
    try {
      let service = users?.filter((item) => item?.serviceId === serviceId);

      const arrayData1 = service?.map((item) => ({
        label: item?.strategyName,
        value: item?.strategyId,
      }));
      const uniqueArray = arrayData1?.filter((obj, index, self) => {
        return index === self?.findIndex((item) => item?.value === obj?.value);
      });
      let filteredArray = uniqueArray?.filter((i) => i?.label && i?.value);
      if (filteredArray?.length === 1) {
        setFieldFunction?.setFieldValue('isRequiredStrategyName', false);
        setFieldFunction?.setFieldValue('strategyNameSelected', filteredArray[0]);
        setFieldFunction?.setFieldValue('strategyName', filteredArray[0]?.value);
      } else if (filteredArray?.length === 0) {
        setFieldFunction?.setFieldValue('isRequiredStrategyName', false);
      } else setFieldFunction?.setFieldValue('isRequiredStrategyName', true);
      setStrategies(() => filteredArray);
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: 'Login: mapStrategies method' };
      HandleException(logError);
    }
  };
  const onError = (error) => {
    isSubmitting = false;
    showAlert('error', apiMessages?.ERROR);
  };

  const onSuccessLoginSevice = (data) => {
    isSubmitting = false;
    const decryptedData = data?.data?.body;
    if (data?.code === 'ERR_NETWORK') showAlert('error', apiMessages?.ERROR);
    if (data?.status === 204) showAlert('error', 'This website does not exist in the database');
    if (data?.response?.status === 500) showAlert('error', apiMessages?.ERROR);
    if (data?.response?.status === 400) {
      if (
        data?.response?.data?.message === 'The client transaction has been successfully completed'
      )
        showAlert('success', data?.response?.data?.message);
      else showAlert('error', data?.response?.data?.message);
    }
    if (data?.status === 200) {
      setTransactionID(decryptedData?.transactionId || '');
      setUserId(decryptedData?.userId);
      handleClickOpen();
    }
  };
  const onErrorLoginService = (error) => {
    isSubmitting = false;
    showAlert('error', apiMessages?.ERROR);
  };
  const { mutate: Login } = useLogin(onSuccess, onError);
  const { mutate: LoginService } = useLoginService(onSuccessLoginSevice, onErrorLoginService);

  const handleLogin = (data) => {
    const submitData = {
      url: window.location.host,
      emailId: data?.emailId,
      mobile: Number(data?.mobile),
    };
    Login(submitData);
  };
  const onErrorResendOTP = (error) => console.error('error', error);
  const { mutate: ResendOTP } = useResendOTP(onErrorResendOTP);

  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  const resendOTP = (type) => {
    let reqDto = {};
    reqDto.OTPType = 'L';
    reqDto.userId = userId;
    reqDto.transactionId = transactionID;
    ResendOTP(reqDto);
  };
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const renderButton = (buttonProps) => <button {...buttonProps}>Resend</button>;

  const renderTime = (remainingTime) => (
    <span>Wait {remainingTime} seconds before resending the OTP.</span>
  );

  const setField = (setFieldValue) => (setFieldFunction.setFieldValue = setFieldValue);

  const callLoginService = (values) => {
    let caughtError;
    try {
      let data = {};
      data.serviceId = useData?.serviceName ? useData?.serviceName : values?.serviceName;
      data.emailId = values?.emailId;
      data.mobile = Number(values?.mobile);
      data.transactionId = values?.transactionId;
      if (transactionID) {
        data.transactionId = transactionID;
      }
      if (values?.userId) {
        data.userId = values?.userId;
      }
      data.url = window?.location?.host;
      data.strategyId = useData?.strategyId ? useData?.strategyId : values?.strategyId;
      LoginService(data);
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: 'Login: loginService method' };
      HandleException(logError);
    }
  };

  const handleSubmitValues = (values) => {
    if (!isSubmitting) {
      if (useData?.serviceName || useData?.strategyId) {
        values.serviceId = useData?.serviceName;
        if (useData?.serviceName) {
          values.isRequiredServiceName = true;
          values.transactionId = transactionID;
        }
        if (useData?.strategyId) {
          values.strategyId = useData?.strategyId;
          values.isRequiredStrategyName = true;
        }
        callLoginService(values);
        isSubmitting = true;
        return;
      }
      if (!values?.serviceName && !values?.strategyName) {
        handleLogin(values);
        isSubmitting = true;
      } else {
        callLoginService(values);
        isSubmitting = true;
      }
    }
  };
  const onClose = () => {
    return navigate('/', { replace: true });
  };
  return (
    <>
      {/* Alert component stays at the top */}

      <div className="modal-overlay">
        <div
          className="modal-container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-heading"
        >
          <Formik
            initialValues={{ ...INITIAL_FORM_STATE_Login }}
            validationSchema={FORM_VALIDATION_Login}
            onSubmit={handleSubmitValues}
          >
            {({ values, setFieldValue, handleSubmit, errors, touched }) => {
              // ✅ Wire up your setField helper exactly as before
              setField(setFieldValue);

              return (
                <Form>
                  {/* ── Left panel: form ──────────────────────────────── */}
                  <div className="modal-content">
                    <div className="modal-form-section">
                      {/* Badge — from designer */}
                      {/* <div className="modal-badge">Institutional Access</div> */}

                      {/* Title — from designer */}
                      <h2 className="modal-title" id="modal-heading">
                        Continue the journey
                      </h2>
                      <p className="modal-subtitle">
                        Enter your Registered Email &amp; Mobile to securely process further
                      </p>

                      <div className="registration-form">
                        {/* ── Email field — designer markup + Formik values ── */}
                        <div className="form-group">
                          <label className="form-label" htmlFor="login-email">
                            EMAIL ID
                          </label>
                          <div className="input-wrapper">
                            <input
                              id="login-email"
                              type="email"
                              className={`form-input ${
                                touched.emailId && errors.emailId ? 'error' : ''
                              }`}
                              placeholder="example@example.com"
                              value={values.emailId}
                              onChange={(e) => setFieldValue('emailId', e.target.value)}
                              onBlur={() => setFieldValue('emailId', values.emailId.trim())}
                            />
                            <span
                              className="material-symbols-outlined input-icon"
                              aria-hidden="true"
                            >
                              mail
                            </span>
                          </div>
                          {touched.emailId && errors.emailId && (
                            <span className="error-text">{errors.emailId}</span>
                          )}
                        </div>

                        {/* ── Mobile field — designer markup + Formik values ── */}
                        <div className="form-group">
                          <label className="form-label" htmlFor="login-mobile">
                            MOBILE NUMBER
                          </label>
                          <div className="input-wrapper">
                            <input
                              id="login-mobile"
                              type="tel"
                              maxLength={10}
                              className={`form-input ${
                                touched.mobile && errors.mobile ? 'error' : ''
                              }`}
                              placeholder="Enter 10 digit number"
                              value={values.mobile}
                              onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, '');
                                setFieldValue('mobile', val);
                              }}
                            />
                            <span
                              className="material-symbols-outlined input-icon"
                              aria-hidden="true"
                            >
                              smartphone
                            </span>
                          </div>
                          {touched.mobile && errors.mobile && (
                            <span className="error-text">{errors.mobile}</span>
                          )}
                        </div>
                      </div>

                      {/* ── Service dropdown — from LoginPage, unchanged ── */}
                      {services.length > 0 && (
                        <div className="form-group mt-2">
                          <label className="form-label">SERVICE</label>
                          <div className="input-wrapper">
                            <select
                              className={`form-input ${
                                touched.serviceName && errors.serviceName ? 'error' : ''
                              }`}
                              value={values.serviceName}
                              onChange={(e) => {
                                setFieldValue('serviceName', e.target.value);
                                mapStrategies(e.target.value);
                              }}
                            >
                              <option value="">Select Service</option>
                              {services.map((s) => (
                                <option key={s.value} value={s.value}>
                                  {s.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          {touched.serviceName && errors.serviceName && (
                            <span className="error-text">{errors.serviceName}</span>
                          )}
                        </div>
                      )}

                      {/* ── Strategy dropdown — from LoginPage, unchanged ── */}
                      {strategies.length > 0 && (
                        <div className="form-group mt-2">
                          <label className="form-label">STRATEGY</label>
                          <div className="input-wrapper">
                            <select
                              className={`form-input ${
                                touched.strategyName && errors.strategyName ? 'error' : ''
                              }`}
                              value={values.strategyName}
                              onChange={(e) => setFieldValue('strategyName', e.target.value)}
                            >
                              <option value="">Select Strategy</option>
                              {strategies.map((s) => (
                                <option key={s.value} value={s.value}>
                                  {s.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          {touched.strategyName && errors.strategyName && (
                            <span className="error-text">{errors.strategyName}</span>
                          )}
                        </div>
                      )}

                      {/* ── Submit button — designer style, LoginPage handler ── */}
                      <button
                        type="button"
                        onClick={handleSubmit}
                        className="submit-btn"
                        disabled={isSubmitting}
                        style={{
                          marginTop: '1rem',
                          width: '100%',
                        }}
                      >
                        {isSubmitting ? (
                          <>
                            <CircularProgress
                              size={18}
                              color="inherit"
                              style={{ marginRight: 8 }}
                            />
                            Login...
                          </>
                        ) : (
                          <>
                            Login
                            {/* <span className="material-symbols-outlined text-sm-icon ml-1">
                              arrow_forward
                            </span> */}
                          </>
                        )}
                      </button>
                    </div>

                    {/* ── Right panel: visual — copied from designer ──────── */}
                    <div className="modal-visual-section">
                      <button className="modal-close" onClick={onClose}>
                        <span className="material-symbols-outlined">close</span>
                      </button>
                      <div className="visual-header">
                        <div className="visual-divider"></div>
                        <span className="visual-tag">
                          {/* Add company name here  */}
                          {/* SECURE LEDGER TECHNOLOGY */}
                        </span>
                      </div>
                      <div className="main-visual-container">
                        <img
                          src="/images/Floating golden city in the sky.png"
                          alt=""
                          className="main-visual-img"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="visual-content">
                        {/* <h3 className="visual-title">Institutional Grade</h3>
                        <p className="visual-description">
                          Connecting elite global markets through refined
                          digital infrastructure and real-time oversight.
                        </p> */}
                        <h6 className="visual-description">
                          Note: Kindly follow the below given instructions
                        </h6>
                        <p className="visual-description">
                          <span>* Enable your camera and location access</span>
                          <br />
                          <span>* Allow pop-up permissions</span>
                        </p>
                      </div>
                      {/* <div className="visual-footer">
                        <div className="avatar-group" aria-hidden="true">
                          <img
                            src="/images/avatar-a.png"
                            alt=""
                            className="avatar-img"
                          />
                          <img
                            src="/images/avatar-b.png"
                            alt=""
                            className="avatar-img"
                          />
                          <div className="avatar-more">+4k</div>
                        </div>
                        <span
                          className="material-symbols-outlined shield-icon"
                          aria-hidden="true"
                        >
                          shield
                        </span>
                      </div> */}
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>

      {/* ── OTP Dialog — from LoginPage, completely unchanged ── */}
      <Dialog open={open} fullScreen={fullScreen}>
        <LoginOTPPopUp
          userId={userId}
          transactionId={transactionID}
          resendOTP={resendOTP}
          handleClose={handleClose}
          renderButton={renderButton}
          renderTime={renderTime}
          showAlert={showAlert}
        />
      </Dialog>

      {/* /login/otp popup */}
      {alert?.counter > 0 && (
        <>
          <CustomizedSnackbars status={alert?.counter} msg={alert?.msg} type={alert?.type} />
          {`ac ${alert?.counter} alert?.msg ${alert?.msg} alert?.type ${alert?.type}  `}
        </>
      )}
    </>
  );
};

export default LoginPage;
